import {Link} from 'react-router-dom';
import {HELP_CATEGORIES, HELP_PAGES} from './helpPages';

export function HelpHome() {
    return (
        <>
            <p>Find information about tax documents, account services, margin borrowing and cash management.</p>
            {HELP_CATEGORIES.map(category => (
                <section key={category} aria-label={category}>
                    <h2>{category}</h2>
                    <dl className="grid gap-4 sm:grid-cols-2">
                        {HELP_PAGES.filter(page => page.category === category).map(page => (
                            <div key={page.path} className="border border-gray-30 rounded p-5">
                                <dt className="text-lg font-medium"><Link to={page.path}>{page.label}</Link></dt>
                                <dd className="mt-2 text-gray-70">{page.description}</dd>
                            </div>
                        ))}
                    </dl>
                </section>
            ))}
        </>
    );
}
